import { render, staticRenderFns } from "./register.vue?vue&type=template&id=37cb4fa2&scoped=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"
import style0 from "./register.vue?vue&type=style&index=0&id=37cb4fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb4fa2",
  null
  
)

export default component.exports